module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "home",
    class: {
      active: _vm.dashFlag
    },
    on: {
      "click": function($event) {
        _vm.activeTo(0)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dashFlag),
      expression: "dashFlag"
    }],
    attrs: {
      "src": require("assets/image/icon-busys-white.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dashFlag),
      expression: "!dashFlag"
    }],
    attrs: {
      "src": require("assets/image/icon-busys-green.png")
    }
  })]), _vm._v(" "), _vm._l((_vm.main_menu), function(data, index) {
    return _c('div', {
      key: data.name,
      staticClass: "main-choice"
    }, [_c('div', {
      staticClass: "main-title",
      class: {
        choice: !_vm.getSecondMenu(data).length, active: _vm.mainChoice(index)
      },
      on: {
        "click": function($event) {
          _vm.activeTo(index + 1)
        }
      }
    }, [_c('div', {
      staticClass: "text"
    }, [_c('img', {
      staticClass: "icon",
      attrs: {
        "src": _vm._f("menuIcon")(data.icon, _vm.mainChoice(index))
      }
    }), _vm._v("\n                " + _vm._s(data.text) + "\n            ")]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.getSecondMenu(data).length),
        expression: "getSecondMenu(data).length"
      }],
      staticClass: "el-icon-arrow-right",
      class: {
        active: _vm.mainChoice(index) && _vm.menu_on
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "second-menu",
      class: {
        active: _vm.mainChoice(index) && _vm.menu_on
      }
    }, _vm._l((_vm.getSecondMenu(data)), function(item, i) {
      return _c('div', {
        key: item.name,
        staticClass: "second-item choice",
        class: {
          active: i == _vm.active_sec_index[index]
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.linkTo(item.name)
          }
        }
      }, [_vm._v("\n                " + _vm._s(item.text) + "\n            ")])
    }))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-354ecdb3!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/frontMenu.vue
// module id = 724
// module chunks = 1